import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { toast } from "react-toastify";

const PrivateAdminRoute = ({ allowedRoles }) => {
  const auth_user = JSON.parse(localStorage.getItem("user"));
  if (allowedRoles.includes(auth_user.user_type)) {
    return <Outlet />;
  } else {
    toast.error("Access denied! You don't have permission to access this route.", { autoClose: 5000 });
    return <Navigate to="/dashboard" />
  }
};

export default PrivateAdminRoute;